import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { public: true }
  },
  {
    path: '/',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/login',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '首页', icon: 'el-icon-s-home' }
      },
      {
        path: 'scenic',
        name: 'Scenic',
        component: () => import('@/views/scenic/index.vue'),
        meta: { title: '景区管理', icon: 'el-icon-s-flag', roles: [1] }
      },
      {
        path: 'timeslot',
        name: 'TimeSlot',
        component: () => import('@/views/timeslot/index.vue'),
        meta: { title: '时段设置', icon: 'el-icon-time' }
      },
      {
        path: 'reservation',
        name: 'Reservation',
        component: () => import('@/views/reservation/index.vue'),
        meta: { title: '预约管理', icon: 'el-icon-s-order' }
      },
      {
        path: 'verify',
        name: 'Verify',
        component: () => import('@/views/verify/index.vue'),
        meta: { title: '核销记录', icon: 'el-icon-circle-check' }
      },
      {
        path: 'statistics',
        name: 'Statistics',
        component: () => import('@/views/statistics/index.vue'),
        meta: { title: '数据统计', icon: 'el-icon-s-data' }
      },
      {
        path: 'banner',
        name: 'Banner',
        component: () => import('@/views/banner/index.vue'),
        meta: { title: '轮播图管理', icon: 'el-icon-picture', roles: [1, 2] }
      },
      {
        path: 'gallery',
        name: 'Gallery',
        component: () => import('@/views/gallery/index.vue'),
        meta: { title: '图册管理', icon: 'el-icon-picture-outline', roles: [1, 2] }
      },
      {
        path: 'config',
        name: 'Config',
        component: () => import('@/views/config/index.vue'),
        meta: { title: '系统配置', icon: 'el-icon-setting', roles: [1] }
      },
      {
        path: 'user',
        name: 'User',
        component: () => import('@/views/user/index.vue'),
        meta: { title: '管理员管理', icon: 'el-icon-user-solid', roles: [1] }
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const token = store.getters.token

  if (to.meta && to.meta.public) {
    if (token && to.path === '/login') {
      next('/dashboard')
      return
    }
    next()
    return
  }

  if (!token) {
    next('/login')
    return
  }

  // 角色权限检查
  if (to.meta && to.meta.roles) {
    const userRole = store.getters.userInfo.role
    if (!to.meta.roles.includes(userRole)) {
      next('/dashboard')
      return
    }
  }

  next()
})

export default router
